module.exports = __webpack_public_path__ + "static/IMG_2753-0567a314340a4369c2ae838e5c2771a5.jpg";